import { Box, Link } from "@mui/material"
import { Link as RouterLink } from "react-router-dom";
import { InfoPanel } from "./InfoPanel";
import { useSelector } from "react-redux";

export const RightMenu = () => {
    const user = useSelector(state => state.login.user);
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', padding: '8px', gap: '8px' }}>
            {/* Right Menu */}
            {/* <IconButton><InfoIcon color="info" /></IconButton> */}
            <InfoPanel />
            {user && <Link component={RouterLink} to="/site-tickets" sx={{ color: 'appShell.chromeText', fontSize: '0.875rem' }}>Site Tickets</Link>}
            <Link component={RouterLink} to="/privacy" sx={{ color: 'appShell.chromeText', fontSize: '0.875rem' }}>Privacy Policy</Link>
            {/* <Link href="/shop">Shop</Link> */}
        </Box>
    );
}
